import React from "react";
import "./RenderingList.css";
import Users from "./Users";



const RenderingList = () => {
    return (
        <>
            <div className="main">
                <Users />
            </div>
        </>
    )
}



export default RenderingList;
